export const getMasterCategories = (status = "") => ({
	url: `/products/master-categories/all?status=${status}`,
	method: "GET",
});

export const updateMasterCategory = (id = "") => ({
	url: `/products/master-categories/${id}`,
	method: "PATCH",
});

export const getCategories = (masterCategoryId = "") => ({
	// url: `/products/categories/all?status=${status}`,
	url: `/products/categories/by-master-category/${masterCategoryId}`,
	method: "GET",
});

export const getProductTypes = () => ({
	url: `/products/product-types?status=`,
	method: "GET",
});

export const createMasterCategory = {
	url: "/products/master-categories",
	method: "POST",
};

export const createSubCategory = {
	url: "/products/categories",
	method: "POST",
};

export const updateSubCategory = (id = "") => ({
	url: `/products/categories/${id}`,
	method: "PATCH",
});

export const deleteSubCategory = (id = "") => ({
	url: `/products/categories/${id}`,
	method: "DELETE",
});

export const uploadMasterCategoriesExcel = {
	url: "/products/master-categories/upload-excel",
	method: "POST",
};

export const getMerchantList = (type = "", page = 0, size = 10) => ({
	url: `/admin/merchants/non-approved?type=${type}&page=${page}&size=${size}`,
	method: "GET",
});

// /non-approved never returns APPROVED merchants — the "Approved" tab needs
// this separate endpoint, otherwise a merchant disappears from the dashboard
// once it's approved.
export const getApprovedMerchantList = (page = 0, size = 10) => ({
	url: `/admin/merchants/approved?page=${page}&size=${size}`,
	method: "GET",
});

export const getMerchantCounts = {
	url: `/admin/merchants/count-based-on-merchants-onboarding`,
	method: "GET",
};

export const emailCompaignURL = (isMulti = false) => {
	if (isMulti)
		return { url: `/admin/emails/to-multiple-recipients`, method: "POST" };
	return { url: `/admin/emails/to-single-recipient`, method: "POST" };
};

export const updateMerchantStatus = {
	url: `/admin/merchants/update-merchant-account-status`,
	method: "PATCH",
};
